import React from 'react';
import { UniversalContentImporter } from './UniversalContentImporter';
import { useBulkResearchImport } from '@/hooks/content-generator/useBulkResearchImport';

interface ProjectImportResearchEmptyStateProps {
  projectId: string;
  onImportComplete?: () => void;
}

export const ProjectImportResearchEmptyState: React.FC<ProjectImportResearchEmptyStateProps> = ({
  projectId,
  onImportComplete
}) => {
  const bulkImportMutation = useBulkResearchImport(projectId);

  const handleBulkImport = async (selectedIds: string[]) => {
    try {
      await bulkImportMutation.mutateAsync(selectedIds);
      onImportComplete?.();
    } catch (error) {
      console.error('Failed to import research:', error);
      throw error;
    }
  };

  return (
    <div className="h-[600px]">
      <UniversalContentImporter
        contentType="research"
        projectId={projectId}
        onBulkImport={handleBulkImport}
        layout="list"
        showBulkActions={true}
        showClearButton={false}
        showSearch={true}
        className="h-full"
      />
    </div>
  );
}; 